export default __webpack_public_path__ + "ee6f6ee7040db224af28c21263984680.svg";